<template>
  <div class="status-list">
    <div class="timeline">
      <div class="timeline-entry" v-for="(status, index) in statuses" :key="index">
        <div class="package-count" v-if="packages">
          {{ status.packageCount }}/<wbr>{{ totalColli }}
        </div>
        <div class="status-details">
          <span class="indicator" :class="status.status"></span>
          <span class="status-header">
            <span class="status-text" :class="status.status">
              {{ status.statusText }}
            </span>
            <span class="text-muted">{{ formatDate(status) }}</span>&nbsp;
            <a v-if="showMarker(status)" href="#" @click.prevent="openMap(status)">
              <i class="icon-pin text-yellow"></i>
            </a>
          </span>
          <div class="signature" v-if="status.podSignatureUrl">
            <img :src="status.podSignatureUrl" alt="signature" />
          </div>
          <div class="pod-name text-muted" v-if="status.podName">
            {{ $lang.translate('track.label.name') }}: {{ status.podName }}
          </div>
          <div class="pod-description text-muted" v-if="status.podDescr">
            {{ $lang.translate('track.label.note')}}: {{ status.podDescr }}
          </div>
          <div class="pod-comment text-muted" v-if="status.podComment">
            {{ $lang.translate('track.label.comment') }}: {{ status.podComment }}
          </div>
        </div>
      </div>
    </div>
    <Modal :active="showModal" class="with-backdrop padded" @close="showModal = false">
      <Map class="big" v-if="point" :point="point" />
    </Modal>
  </div>
</template>

<script>
import { dateFormat } from '@/utils'
import Modal from '@/components/Modal'
import Map from '@/components/result/Map'
export default {
  props: {
    totalColli: {
      type: Number, 
      required: true
    },
    statuses: {
      type: Array,
      required: true
    },
    packages: {
      type: Array,
      required: false
    },
    maps: {
      type: Object
    }
  },
  data () {
    return {
      showModal: false,
      mapStatus: null,
      point: null
    }
  },
  methods: {
    formatDate(status) {
      const dateTime = status.dateAndTime
      const time = dateFormat(dateTime, { hour: 'numeric', minute: 'numeric', hour12: false })
      const date = dateFormat(dateTime, { year: 'numeric', month: 'numeric', day: 'numeric' })
      return  this.showTime(status, time) ? date + ' - ' + time : date
    },
    showMarker(status) {
      return this.$mapsEnabled && this.maps && status.latitude && status.longitude
    },
    openMap(status) {
      if (status.latitude && status.longitude) {
        this.point = {lat: status.latitude, lng: status.longitude}
        this.showModal = true
      }
    },
    showTime (status, time) {
      if (time === '23:59' || time === '00:00' || time === '24:00') {
        return false
      }
      if ((time === '00:00' || time === '24:00') && status.status === 'created' && status.sourceSystem === 'carlo') {
        return false
      }
      return true
    }
  },
  components: {
    Modal,
    Map
  }
}
</script>

<style scoped>
.status-details {
  border-left: 5px solid #D3D3D3;
  position: relative;
  padding-left: 40px;
}
.timeline-entry:last-child .status-details {
  border-color: transparent;
}

.timeline-entry:not(:last-child) .status-details {
  min-height: 65px;
  padding-bottom: 20px;
}
.timeline-entry {
  display: flex;
}
.package-count {
  width: 60px;
  opacity: 0;
}

@media(max-width: 1023px) {
  .package-count {
    display: none;
  }

  .status-text {
    display: block;
  }
}

.timeline-entry:hover .package-count {
  opacity: 1;
}

.indicator {
  width: 30px;
  height: 30px;
  display: inline-block;
  background: #D3D3D3;
  border: 5px solid #fff;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: -2px;
  transform: translateX(-50%);
}

.status-header {
  display: block;
  margin-top: 2px;
}

.indicator.delivered {
  background-color: #AAD51E;
}

.status-text.delivered {
  font-weight: 700;
  color: #AAD51E;
}
.text-muted {
  color: #AAAAAA;
}
</style>